import { Directive, ElementRef, HostListener, Input, OnDestroy } from '@angular/core';

import '../../../../vendor/imagezoom/imagezoom.min';
import '../../../../vendor/imagezoom/imagezoom.css';

// Hover-to-zoom on an image. Bind `false` to leave the image as it is.
@Directive({
  selector: 'img[worImageZoom]'
})
export class ImageZoomDirective implements OnDestroy {
  @Input() worImageZoom : boolean | '' = true;

  constructor (
    private element : ElementRef<HTMLImageElement>
  ) {}

  ngOnDestroy () : void {
    $(this.element.nativeElement).data('imagezoom')?.destroy();
  }

  @HostListener('load')
  onLoad () : void {
    const image = this.element.nativeElement;

    // The plugin builds markup from the src and alt attributes,
    // so values that could break out of them are not zoomed.
    if ( this.worImageZoom === false || /["'<>]/.test(`${ image.getAttribute('src') }${ image.alt }`) ) {
      return;
    }

    const element = $(image);

    element.data('imagezoom')?.destroy();

    element.css({
      'min-height': image.height,
      'min-width' : image.width
    });

    // The bundled jQuery plugin has no TypeScript declarations.
    element['ImageZoom']();
  }
}
